module.exports = __webpack_public_path__ + "static/img/HR.f1da2b9f.png";